import axios from '../config/axios';

export function apiSend(id, name, subject) {
	return axios.post('live', {id: id, name: name, subject: subject});
}
